import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopContext } from '../context/shopContext';

function Search({ closeSearch }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const { searchProducts } = useContext(ShopContext); // Access the searchProducts function
  const navigate = useNavigate();

  // Handle live search suggestions
  const handleInputChange = async (e) => {
    const input = e.target.value;
    setSearchTerm(input);

    if (input.trim().length > 2) {
      const results = await searchProducts(input); // Fetch suggestions
      setSuggestions(results);
    } else {
      setSuggestions([]); // Clear suggestions if input is too short
    }
  };

  // Handle search submission
  const handleSearchSubmit = (e) => {
    e.preventDefault();

    if (searchTerm.trim() !== '') {
      navigate(`/search?query=${searchTerm}`); // Navigate to the search results page
      closeSearch(); // Close the search overlay
    }
  };

  // Handle click on suggestion
  const handleSuggestionClick = (product) => {
    navigate(`/product/${product.id.split('/').pop()}`); // Navigate to product page
    closeSearch(); // Close the search overlay
  };

  return (
    <div className="absolute top-0 left-0 w-full h-full bg-white z-50">
      {/* Search Bar */}
      <div className="w-full flex justify-center items-center border-b border-gray-400 py-2 relative h-14">
        {/* Input Field */}
        <form
          onSubmit={handleSearchSubmit}
          className="w-full flex justify-center items-center relative"
        >
          <input
            type="text"
            value={searchTerm}
            onChange={handleInputChange}
            className="w-3/4 text-lg font-light border-none focus:outline-none h-full"
            style={{ padding: '0', verticalAlign: 'middle' }}
            placeholder="Search for products..."
          />

          {/* Submit Search Button */}
          <button
            type="submit"
            className="absolute right-16 text-sm focus:outline-none italic"
            style={{ top: '50%', transform: 'translateY(-50%)' }}
          >
            Search
          </button>

          {/* Close Search Button (X) */}
          <button
            onClick={closeSearch}
            className="absolute right-8 text-2xl focus:outline-none"
            style={{ top: '50%', transform: 'translateY(-50%)' }}
          >
            &times;
          </button>
        </form>
      </div>

      {/* Suggestions Dropdown */}
      {suggestions.length > 0 && (
        <div className="absolute left-1/2 transform -translate-x-1/2 bg-white shadow-md rounded mt-2 w-3/4 md:w-1/2 max-h-60 overflow-y-auto">
          {suggestions.map((product) => (
            <div
              key={product.id}
              className="flex items-center py-1 px-2 border-b last:border-none cursor-pointer hover:bg-gray-100"
              onClick={() => handleSuggestionClick(product)}
            >
              {/* Product Image */}
              <img
                src={product.images.edges[0]?.node.src || ''}
                alt={product.title}
                className="w-12 h-12 object-cover rounded-md mr-3"
              />

              {/* Product Info */}
              <div>
                <p className="font-medium text-sm">{product.title}</p>
                <p className="text-xs text-gray-500">
                  {Math.floor(product.variants.edges[0]?.node.price.amount || 0)}{' '}
                  {product.variants.edges[0]?.node.price.currencyCode || ''}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Search;
